export default {
  SET_MEMBER_DATA(state, memberData) {
    state.members = memberData;
  },
  SET_MEMBER_RECORDS(state, totalMembers) {
    state.totalMembers = totalMembers;
  },
  SET_CURRENT_PAGE(state, data) {
    state.members.currentPage = data;
  },
};
